import { TFunction } from 'i18next';

import { IOrderHistory } from '@aqx-core/common/api/order';
import dayjs, {
  DATETIME_FORMAT,
  DATETIME_WITH_DOT_FORMAT,
  DATE_FORMAT,
  DATE_WITH_DOT_FORMAT
} from '@aqx-core/common/dayjs';
import { companyViewController } from '@aqx-core/common/services/company/controller';

const formatExpiredDate = (date: string): string => {
  const trimmed = date.trim();
  const bracketMatch = trimmed.match(/^\[(.+)\]$/);
  if (!bracketMatch) {
    return date;
  }

  const dateContent = bracketMatch[1];

  // Date with time in brackets: input is server time, convert to device local time only if tenant uses device time
  if (dayjs(dateContent, DATETIME_WITH_DOT_FORMAT, true).isValid()) {
    const isServerTime = companyViewController.getMarketTimeIsServer();

    if (isServerTime) {
      return `[${dayjs(dateContent, DATETIME_WITH_DOT_FORMAT).format(DATETIME_FORMAT)}]`;
    }

    const serverOffsetHours = companyViewController.getUserServerTimezoneOffset() ?? 0;
    const formatted = dayjs
      .utc(dateContent, DATETIME_WITH_DOT_FORMAT)
      .subtract(serverOffsetHours, 'hour')
      .local()
      .format(DATETIME_FORMAT);
    return `[${formatted}]`;
  }

  // Date only: just reformat dots to dashes, no timezone conversion
  if (dayjs(dateContent, DATE_WITH_DOT_FORMAT, true).isValid()) {
    return `[${dayjs(dateContent, DATE_WITH_DOT_FORMAT).format(DATE_FORMAT)}]`;
  }

  return date;
};

export const formatExitMethod = (value: string | number | undefined, _row: IOrderHistory, t: TFunction) => {
  const stringValue = value?.toString();
  if (!stringValue || stringValue === '--') {
    return '--';
  }

  if (stringValue.toLowerCase().includes('expired')) {
    const date = stringValue.split(' ').slice(1).join(' ');
    if (date) {
      const formattedDate = formatExpiredDate(date);
      return `${t('Expired')} ${formattedDate}`;
    }
    return t('Expired');
  }

  if (stringValue.includes('Triggered by Take Profit')) {
    return t('Triggered by Take Profit');
  }

  if (stringValue.includes('Triggered by Stop Loss')) {
    return t('Triggered by Stop Loss');
  }

  return stringValue;
};
